import React from 'react';
import styles from './TextEffectsOutlineOut.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { TestIds } from '../constants';
import { blendModes } from '../../TextEffectsShared/constants';

export type TextEffectsOutlineOutProps = TextEffectsSharedProps;

const ANGLE_RANGE = [0, 45, 90, 135, 180, 225, 270, 315];

const TextEffectsOutlineOut: React.FC<TextEffectsSharedProps> = props => {
  const { text, id } = props;

  return (
    <TextEffectsShared {...props}>
      <svg className={styles.visuallyHidden}>
        <defs>
          {ANGLE_RANGE.map(azimuth => (
            <filter
              key={azimuth}
              id={`outline-out-lightA3_azimuth:${azimuth}-${id}`}
            >
              <feGaussianBlur in="SourceAlpha" stdDeviation="3" result="B" />
              <feSpecularLighting in="B" specularExponent="128" result="S">
                <feDistantLight azimuth={azimuth} elevation="72" />
              </feSpecularLighting>
              <feComposite in="S" in2="SourceAlpha" operator="in" result="L" />
              <feComposite
                in="SourceGraphic"
                in2="L"
                operator="arithmetic"
                k2="1"
                k3="1"
              />
            </filter>
          ))}
          {blendModes.map(({ value }) => (
            <filter
              key={value}
              id={`outline-out-dark-glass_blend-mode:${value}-${id}`}
            >
              <feBlend result="A" mode="screen" in2="SourceGraphic" />
              <feGaussianBlur stdDeviation="2" result="B" />
              <feComposite operator="xor" in="B" in2="A" result="C" />
              <feComposite result="fC" in="C" operator="xor" in2="C" />
              <feGaussianBlur result="B" stdDeviation="3" in="fC" />
              <feSpecularLighting
                result="S"
                specularExponent="55"
                specularConstant="1.5"
                surfaceScale="6"
                in="B"
              >
                <fePointLight z="20000" y="-8000" x="-5000" />
              </feSpecularLighting>
              <feComposite
                in="B"
                k3="1"
                k2="1.5"
                operator="arithmetic"
                in2="SourceGraphic"
                result="C"
              />
              <feComposite in="S" operator="atop" in2="C" result="C" />
              <feBlend mode={value} in2="C" />
            </filter>
          ))}
        </defs>
      </svg>

      <div
        className={styles.container}
        data-testid={TestIds.viewer.container}
        data-text={text}
      >
        <span className={styles.text} data-testid={TestIds.viewer.text}>
          {text}
        </span>
      </div>
    </TextEffectsShared>
  );
};

export default TextEffectsOutlineOut;
